import { createFileRoute, Navigate } from '@tanstack/react-router';
import { z } from 'zod';

import { useAuth } from '../../context/AuthContext';
import { CustomerDetails } from '../../modules/CustomerDetails/components/CustomerDetails';

const searchSchema = z.object({
  showCreateProperty: z.boolean().optional(),
  tab: z.string().optional(),
});

export const Route = createFileRoute('/customers/$customerId')({
  component: CustomerDetailsPage,
  params: z.object({
    customerId: z.coerce.number().positive(),
  }),
  validateSearch: searchSchema,
  head: () => ({
    meta: [
      {
        title: 'Customer Details',
      },
    ],
  }),
});

function CustomerDetailsPage() {
  const { customerId } = Route.useParams();
  const { user } = useAuth();

  if (!user.preferAdminView) {
    return <Navigate to="/customer-details/$customerId" params={{ customerId }} replace />;
  }

  return <CustomerDetails userID={customerId} />;
}
